import React from 'react';
import { Award, Users, Camera, TrendingUp } from 'lucide-react';

const AboutSection = () => {
  const stats = [
    {
      icon: Camera,
      value: '1 an',
      label: "d'expérience"
    },
    {
      icon: Users,
      value: '100+',
      label: 'clients satisfaits'
    },
    {
      icon: Award,
      value: '13',
      label: 'marques photographiées'
    },
    {
      icon: TrendingUp,
      value: '∞',
      label: 'passion automobile'
    }
  ];

  return (
    <section
      id="about"
      className="section-spacing-large"
      style={{ backgroundColor: 'var(--color-black)' }}
    >
      <div className="container-artworld">
        {/* Section Title */}
        <div className="text-center mb-16">
          <p className="label-text mb-4">Découvrez</p>
          <h2 className="section-title">À Propos de W Shoot</h2>
          <div
            className="w-24 h-1 mx-auto mt-6"
            style={{
              background: 'linear-gradient(90deg, transparent, var(--color-red-accent), transparent)'
            }}
          />
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <p className="body-text">
              Je suis <strong style={{ color: 'var(--color-white)' }}>photographe automobile passionné</strong> spécialisé dans les{' '}
              <strong style={{ color: 'var(--color-white)' }}>véhicules d'exception</strong>.
            </p>
            <p className="body-text">
              Je pense chaque shooting comme une <strong style={{ color: 'var(--color-white)' }}>mise en scène cinématique</strong>, 
              capturant la puissance, les lignes, et l'émotion mécanique de chaque machine.
            </p>
            <p className="body-text">
              Des supercars aux motos, chaque véhicule mérite une image à sa hauteur. 
              Plus de <strong style={{ color: 'var(--color-white)' }}>100 passionnés</strong> m'ont déjà fait confiance 
              pour immortaliser leurs véhicules lors de rassemblements automobiles en France et à Monaco.
            </p>
            <p className="body-text">
              La photographie automobile est bien plus qu'un métier, c'est ma{' '}
              <strong style={{ color: 'var(--color-chrome)' }}>passion</strong> qui se ressent dans chaque cliché.
            </p>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 gap-8">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="relative p-8 group"
                style={{
                  background: 'var(--color-carbon)',
                  border: '1px solid var(--color-dark-gray)',
                  transition: 'all var(--transition-normal)'
                }}
              >
                {/* Hover Effect */}
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  style={{
                    background: 'linear-gradient(135deg, rgba(220, 38, 38, 0.1) 0%, transparent 100%)',
                    border: '1px solid var(--color-red-accent)'
                  }}
                />

                {/* Content */}
                <div className="relative z-10 text-center">
                  <stat.icon
                    size={32}
                    className="mx-auto mb-4"
                    style={{ color: 'var(--color-red-accent)' }}
                  />
                  <div
                    className="brand-name mb-2"
                    style={{
                      fontSize: 'clamp(2rem, 3vw, 3rem)',
                      color: 'var(--color-white)'
                    }}
                  >
                    {stat.value}
                  </div>
                  <div className="label-text">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
